import vmClient from '../../services/vmClient';
import { Entity, EntityStringId, IEntityType, IEntity } from '../../types/entity';
import { Ability, AbilityMarshaller } from 'app/constants/enums/Ability';
import { StaffPosition, StaffPositionMarshaller } from 'app/constants/enums/StaffPosition';
import { StaffTeam, StaffTeamMarshaller } from 'app/constants/enums/StaffTeam';
import { IUser } from './User';
import { UserProfile } from './UserProfile';

export interface IStaffMember extends IEntity {
  attributes: {
    id: EntityStringId;
    enabled: boolean;
    staffName: string;
    staffEmail: string;
    abilities: Ability[];
    staffTeams: StaffTeam[];
    staffPositions: StaffPosition[];
  };
  associations: {
    user: IUser;
  };
}

export type StaffMember = Entity<IStaffMember>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const StaffMember: IEntityType<IStaffMember> = vmClient.defineClass({
  typeName: 'StaffMember',
  version: 3,
  lockable: true,
  persisted: true,

  attributes: {
    staffEmail: {
      type: 'string',
      notNull: true,
    },
    staffName: {
      type: 'string',
      notNull: true,
    },
    abilities: {
      collection: true,
      type: Ability,
      marshaller: AbilityMarshaller,
    },
    staffTeams: {
      collection: true,
      type: StaffTeam,
      marshaller: StaffTeamMarshaller,
    },
    staffPositions: {
      collection: true,
      type: StaffPosition,
      marshaller: StaffPositionMarshaller,
    },
    enabled: {
      type: 'boolean',
    },
  },
  associations: {
    user: {
      type: UserProfile,
      shared: true,
    },
  },
});
